module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_CN.0439a3ad.txt";